// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"719":"aa14054a","787":"07ab12c1","965":"5eeeae25"}[chunkId] + ".chunk.js";
};